import React from "react"
import styles from "./blockImgLeftFloatingText.module.css"

const BlockImgLeftFloatingText = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data
  return (
    <section className={styles.blockImgLeftFloatingText}>
      <div className={styles.blockImgLeftFloatingText__bgBlack} />
      <div className={styles.blockImgLeftFloatingText__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt={title} />
      </div>
      <div className={styles.blockImgLeftFloatingText__titleText}>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>

      <div className={styles.blockImgLeftFloatingText__bgRed} />
    </section>
  )
}
export default BlockImgLeftFloatingText
